"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var stacktrace_js_1 = require("stacktrace-js");
var platform = require("platform");
var config = {
    stackTraceOptions: {},
    projectId: 0,
    projectEnv: "default",
};
// const t25min = 25 * 60 * 1000
// let token: { value: string, stamp: number } = { value: "", stamp: 0 }
exports.setErrorLoggerConfig = function (c) { return Object.assign(config, c); };
var getData = function (traces) {
    return JSON.stringify({
        Url: location.href,
        ErrorMessage: "JavaScript runtime error",
        Errors: traces.map(function (x) { return ({
            Message: x.toString(),
        }); }),
        Browser: "browser: " + platform.name + ", version: " + platform.version,
        OperatingSystem: "os: " + platform.os + ", device: " + (platform.manufacturer || "") + " " + platform.product,
    });
};
exports.request = function (path, data, headers) {
    return new Promise(function (res, rej) {
        var xhr = new XMLHttpRequest();
        xhr.open("POST", "https://dotnetlogclient.orange-juice.nl/" + path, true);
        xhr.setRequestHeader("Content-Type", "application/json");
        if (headers)
            headers.forEach(function (_a) {
                var k = _a[0], v = _a[1];
                return xhr.setRequestHeader(k, v);
            });
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status >= 200 && xhr.status < 400)
                    res(xhr.responseText);
                else
                    rej(xhr);
            }
        };
        xhr.onerror = function () { return rej(xhr); };
        xhr.send(data);
    });
};
// export const getToken = () =>
//   request(`token/GenerateToken?env=${config.projectEnv}`, JSON.stringify({ Username: "michel", Password: "OJ_Auth" }))
//     .then(value => token = { value, stamp: Date.now() })
exports.postStackTrace = function (traces) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (config.projectId === 0)
            throw new Error("Please set the config by calling setErrorLoggerConfig(config: IErrorLoggerConfig)");
        // if (Date.now() - token.stamp > t25min)
        //   await getToken()
        // if (!token) throw new Error("No Bearer token provided")
        return [2 /*return*/, exports.request("projects/" + config.projectId + "/messages?env=" + config.projectEnv, getData(traces))]; // , [["Authorization", `Bearer ${token}`]]
    });
}); };
exports.postStackTraceFromError = function (error) {
    return stacktrace_js_1.fromError(error, config.stackTraceOptions)
        .then(function (x) { return exports.postStackTrace(x); })
        .then(function (x) { return console.log(x); })
        .catch(function (x) { return console.error(x); });
};
var prevOnErrorFn = window.onerror;
window.onerror = function (msg, file, line, col, error) {
    exports.postStackTraceFromError(error);
    if (typeof prevOnErrorFn === "function")
        prevOnErrorFn(msg, file, line, col, error);
    return true;
};
